import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { sectorEmr } from "../../../../../../../services/sectorEmr.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const Sector = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(sectorEmr);

  const [options, setOptions] = useState<ISelectType[]>([]);

  const fetchOptions = useCallback(async () => {
    const { data, success } = await sendRequest({});
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: String(item.identifier),
          name: item.name,
        })),
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoCompleteMulti
        options={options}
        name="uBusIntegrationRuleMovSectors"
        size="small"
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "sector")}
        keepOpenOnSelect
      />
    </Grid>
  );
});
